<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Phaser 4 Game</title>
  <script type="module" src="./main.ts"></script>
</head>
<body>
  <div id="game-container"></div>
</body>
</html>
